import { RadioGroup } from '@velocity/ui'

import { useContent } from '@ngb-frontend/shared/context'
import { TimeSlot } from '@ngb-frontend/shared/types'
import { validation as v } from '@ngb-frontend/shared/utils'

import { FormField } from '../FormField/FormField'

import type { TimeSlotFieldProps } from '@ngb-frontend/shared/types'

export const TimeSlotField: React.FC<TimeSlotFieldProps> = ({
  name = 'timeSlot',
  noMargin,
  label,
  hideLabel,
  options,
  required,
  renderKey,
}) => {
  const c = useContent()

  const validator = v.compose(
    required
      ? v.apply(v.required, {
          message: c('errors.required'),
          type: 'errorType',
        })
      : undefined,
  )

  return (
    <FormField<TimeSlot>
      key={renderKey}
      name={name}
      id="time-slot-input"
      label={label || c('fields.timeSlot.label')}
      hideLabel={hideLabel}
      hideOptionalLabel={true}
      validator={validator}
      noMargin={noMargin}
    >
      {({ input }) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { onFocus, onBlur, ...rest } = input

        return (
          <RadioGroup
            {...rest}
            data-e2e-component="time-slot-input"
            value={`${input.value}`}
            required={false}
            options={
              options || [
                {
                  value: TimeSlot.AllDay,
                  label: c('fields.timeSlot.All Day.label'),
                },
                {
                  value: TimeSlot.AM,
                  label: c('fields.timeSlot.AM.label'),
                },
                {
                  value: TimeSlot.PM,
                  label: c('fields.timeSlot.PM.label'),
                },
              ]
            }
          />
        )
      }}
    </FormField>
  )
}
